import type { PriceId } from '@iheartjane/types';

import type { BrandSpecials } from '@jane/bloom/types/schemas/marketplace/brandSpecials';
import { getApplicableGoldTagLabel } from '@jane/bloom/utils/gold/getJaneGoldTagLabel';

interface GetGoldLabelArgs {
  applicableBrandSpecialIds: number[];
  brandSpecials: BrandSpecials;
  lowestAvailablePriceVal?: string | null;
}

export function getGoldLabel({
  applicableBrandSpecialIds,
  brandSpecials,
  lowestAvailablePriceVal,
}: GetGoldLabelArgs): string | null {
  if (!applicableBrandSpecialIds.length || !brandSpecials.length) return null;

  return getApplicableGoldTagLabel({
    applicableBrandSpecialIds,
    brandSpecials,
    priceId: lowestAvailablePriceVal?.split('price_')[1] as PriceId | undefined,
  });
}
